import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class ButtonType extends AStringEnum
{
    public static BUTTON = new AString('Button');
    public static LINK_BUTTON = new AString('Link Button');

    private static _types:Array<AString> = [
        ButtonType.BUTTON,
        ButtonType.LINK_BUTTON
    ];

    public constructor(value:AString)
    {
        super(value, ButtonType._types);
    }

    public static button():ButtonType
    {
        return new ButtonType(ButtonType.BUTTON);
    }

    public static linkButton():ButtonType
    {
        return new ButtonType(ButtonType.LINK_BUTTON);
    }
}
